// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRenewalHealthPlanDto } from './IRenewalHealthPlanDto';
import {
    IRenewalHealthPlanDtoFromJSON,
    IRenewalHealthPlanDtoFromJSONTyped,
    IRenewalHealthPlanDtoToJSON,
    IRenewalHealthPlanDtoToJSONTyped,
} from './IRenewalHealthPlanDto';
import type { IRenewalPlanDto } from './IRenewalPlanDto';
import {
    IRenewalPlanDtoFromJSON,
    IRenewalPlanDtoFromJSONTyped,
    IRenewalPlanDtoToJSON,
    IRenewalPlanDtoToJSONTyped,
} from './IRenewalPlanDto';
import type { IRenewalPayrollCalendarDto } from './IRenewalPayrollCalendarDto';
import {
    IRenewalPayrollCalendarDtoFromJSON,
    IRenewalPayrollCalendarDtoFromJSONTyped,
    IRenewalPayrollCalendarDtoToJSON,
    IRenewalPayrollCalendarDtoToJSONTyped,
} from './IRenewalPayrollCalendarDto';
import type { IRenewalCopayDto } from './IRenewalCopayDto';
import {
    IRenewalCopayDtoFromJSON,
    IRenewalCopayDtoFromJSONTyped,
    IRenewalCopayDtoToJSON,
    IRenewalCopayDtoToJSONTyped,
} from './IRenewalCopayDto';
import type { IOrganizationAddressInfoDto } from './IOrganizationAddressInfoDto';
import {
    IOrganizationAddressInfoDtoFromJSON,
    IOrganizationAddressInfoDtoFromJSONTyped,
    IOrganizationAddressInfoDtoToJSON,
    IOrganizationAddressInfoDtoToJSONTyped,
} from './IOrganizationAddressInfoDto';
import type { IRenewalPlanYearDto } from './IRenewalPlanYearDto';
import {
    IRenewalPlanYearDtoFromJSON,
    IRenewalPlanYearDtoFromJSONTyped,
    IRenewalPlanYearDtoToJSON,
    IRenewalPlanYearDtoToJSONTyped,
} from './IRenewalPlanYearDto';

/**
 * 
 * @export
 * @interface IRenewalRecordExtendedDto
 */
export interface IRenewalRecordExtendedDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordExtendedDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordExtendedDto
     */
    org_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    org_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    org_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    partner_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordExtendedDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {IRenewalPlanYearDto}
     * @memberof IRenewalRecordExtendedDto
     */
    plan_year?: IRenewalPlanYearDto;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    status?: IRenewalRecordExtendedDtoStatusEnum;
    /**
     * 
     * @type {IRenewalPlanYearDto}
     * @memberof IRenewalRecordExtendedDto
     */
    new_plan_year?: IRenewalPlanYearDto;
    /**
     * 
     * @type {Array<IRenewalPlanDto>}
     * @memberof IRenewalRecordExtendedDto
     */
    plans?: Array<IRenewalPlanDto>;
    /**
     * 
     * @type {Array<IRenewalHealthPlanDto>}
     * @memberof IRenewalRecordExtendedDto
     */
    health_plans?: Array<IRenewalHealthPlanDto>;
    /**
     * 
     * @type {Array<IRenewalCopayDto>}
     * @memberof IRenewalRecordExtendedDto
     */
    copays?: Array<IRenewalCopayDto>;
    /**
     * 
     * @type {Array<IRenewalPayrollCalendarDto>}
     * @memberof IRenewalRecordExtendedDto
     */
    payroll_calendars?: Array<IRenewalPayrollCalendarDto>;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    plan_renewal_note?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    privacy_policy_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    terms_and_conditions_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    pricing_consent_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    dark_large_logo_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordExtendedDto
     */
    allow_renewals_type?: IRenewalRecordExtendedDtoAllowRenewalsTypeEnum;
    /**
     * 
     * @type {Set<IOrganizationAddressInfoDto>}
     * @memberof IRenewalRecordExtendedDto
     */
    addresses?: Set<IOrganizationAddressInfoDto>;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalRecordExtendedDtoStatusEnum {
    NEW = 'NEW',
    REQUESTED = 'REQUESTED',
    CANCELED = 'CANCELED',
    ACTIVE = 'ACTIVE',
    PROCESSING = 'PROCESSING',
    COMPLETE = 'COMPLETE',
    RESOLVED = 'RESOLVED'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalRecordExtendedDtoAllowRenewalsTypeEnum {
    NO_RENEWALS = 'NO_RENEWALS',
    BY_REQUEST = 'BY_REQUEST'
}


/**
 * Check if a given object implements the IRenewalRecordExtendedDto interface.
 */
export function instanceOfIRenewalRecordExtendedDto(value: object): value is IRenewalRecordExtendedDto {
    return true;
}

export function IRenewalRecordExtendedDtoFromJSON(json: any): IRenewalRecordExtendedDto {
    return IRenewalRecordExtendedDtoFromJSONTyped(json, false);
}

export function IRenewalRecordExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalRecordExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'org_name': json['org_name'] == null ? undefined : json['org_name'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'plan_year': json['plan_year'] == null ? undefined : IRenewalPlanYearDtoFromJSON(json['plan_year']),
        'status': json['status'] == null ? undefined : json['status'],
        'new_plan_year': json['new_plan_year'] == null ? undefined : IRenewalPlanYearDtoFromJSON(json['new_plan_year']),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IRenewalPlanDtoFromJSON)),
        'health_plans': json['health_plans'] == null ? undefined : ((json['health_plans'] as Array<any>).map(IRenewalHealthPlanDtoFromJSON)),
        'copays': json['copays'] == null ? undefined : ((json['copays'] as Array<any>).map(IRenewalCopayDtoFromJSON)),
        'payroll_calendars': json['payroll_calendars'] == null ? undefined : ((json['payroll_calendars'] as Array<any>).map(IRenewalPayrollCalendarDtoFromJSON)),
        'plan_renewal_note': json['plan_renewal_note'] == null ? undefined : json['plan_renewal_note'],
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'pricing_consent_link': json['pricing_consent_link'] == null ? undefined : json['pricing_consent_link'],
        'dark_large_logo_path': json['dark_large_logo_path'] == null ? undefined : json['dark_large_logo_path'],
        'allow_renewals_type': json['allow_renewals_type'] == null ? undefined : json['allow_renewals_type'],
        'addresses': json['addresses'] == null ? undefined : (new Set((json['addresses'] as Array<any>).map(IOrganizationAddressInfoDtoFromJSON))),
    };
}

export function IRenewalRecordExtendedDtoToJSON(json: any): IRenewalRecordExtendedDto {
    return IRenewalRecordExtendedDtoToJSONTyped(json, false);
}

export function IRenewalRecordExtendedDtoToJSONTyped(value?: IRenewalRecordExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'org_id': value['org_id'],
        'org_name': value['org_name'],
        'org_path': value['org_path'],
        'partner_name': value['partner_name'],
        'plan_year_id': value['plan_year_id'],
        'plan_year': IRenewalPlanYearDtoToJSON(value['plan_year']),
        'status': value['status'],
        'new_plan_year': IRenewalPlanYearDtoToJSON(value['new_plan_year']),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IRenewalPlanDtoToJSON)),
        'health_plans': value['health_plans'] == null ? undefined : ((value['health_plans'] as Array<any>).map(IRenewalHealthPlanDtoToJSON)),
        'copays': value['copays'] == null ? undefined : ((value['copays'] as Array<any>).map(IRenewalCopayDtoToJSON)),
        'payroll_calendars': value['payroll_calendars'] == null ? undefined : ((value['payroll_calendars'] as Array<any>).map(IRenewalPayrollCalendarDtoToJSON)),
        'plan_renewal_note': value['plan_renewal_note'],
        'privacy_policy_link': value['privacy_policy_link'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'pricing_consent_link': value['pricing_consent_link'],
        'dark_large_logo_path': value['dark_large_logo_path'],
        'allow_renewals_type': value['allow_renewals_type'],
        'addresses': value['addresses'] == null ? undefined : (Array.from(value['addresses'] as Set<any>).map(IOrganizationAddressInfoDtoToJSON)),
    };
}

